import React from "react";

const DragIcon = ({ color = "currentColor", ...props }) => (
  <svg width="24" viewBox="0 0 18 18" {...props}>
    <path
      fill={color}
      d="M7.25 2a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7.25 9a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7.25 16a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M14.25 2a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M14.25 9a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M14.25 16a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"
    />
  </svg>
);

export default DragIcon;
